export default __webpack_public_path__ + "static/media/BlindSummaryIcon.e157454b.svg";